import { Spinner } from 'react-bootstrap';

const BasicSpinner = ({ color = 'primary' }) => (
  <Spinner className={`ml-2 color-${color}`} as="span" animation="border" size="sm" role="status" aria-hidden="true" />
);

export default BasicSpinner;
